(function () {
  function initTournamentSubmissionForms() {
    document.querySelectorAll('.tournament-submission-form').forEach(function (form) {
      if (form.dataset.tournamentSubmissionInit === 'true') return;
      form.dataset.tournamentSubmissionInit = 'true';

      var divisionCheckboxes = form.querySelectorAll('[data-division-checkbox]');
      var divisionOutput = form.querySelector('[data-divisions-output]');
      var divisionError = form.querySelector('[data-division-error]');
      var isUpdateCheckbox = form.querySelector('[data-is-update-checkbox]');
      var isUpdateOutput = form.querySelector('[data-is-update-output]');
      var bodyField = form.querySelector('[data-submission-body]');
      var startDate = form.querySelector('[data-start-date]');
      var endDate = form.querySelector('[data-end-date]');
      var websiteUrl = form.querySelector('[name="contact[website_url]"]');
      var logoUrl = form.querySelector('[name="contact[logo_url]"]');

      function getSelectedDivisions() {
        return Array.prototype.slice
          .call(divisionCheckboxes)
          .filter(function (checkbox) {
            return checkbox.checked;
          })
          .map(function (checkbox) {
            return checkbox.value;
          });
      }

      function syncDivisions() {
        if (!divisionOutput) return;
        divisionOutput.value = getSelectedDivisions().join(', ');
      }

      function syncIsUpdate() {
        if (!isUpdateOutput || !isUpdateCheckbox) return;
        isUpdateOutput.value = isUpdateCheckbox.checked ? 'Yes' : 'No';
      }

      function normalizeUrlField(field) {
        if (!field) return;
        var value = field.value.trim();
        if (!value) return;
        if (!/^https?:\/\//i.test(value)) {
          field.value = 'https://' + value;
        }
      }

      function buildSummary() {
        if (!bodyField) return;

        var fields = {
          'Tournament name': form.querySelector('[name="contact[name]"]'),
          'Submitter email': form.querySelector('[name="contact[email]"]'),
          'League name': form.querySelector('[name="contact[league_name]"]'),
          'Start date': startDate,
          'End date': endDate,
          'Location': form.querySelector('[name="contact[location]"]'),
          'Website URL': websiteUrl,
          'Logo URL': logoUrl,
          'Divisions': { value: getSelectedDivisions().join(', ') },
          'Update submission': { value: isUpdateCheckbox && isUpdateCheckbox.checked ? 'Yes' : 'No' }
        };

        var lines = ['Tournament submission received:', ''];

        Object.keys(fields).forEach(function (label) {
          var field = fields[label];
          var value = field && field.value ? field.value.trim() : '';
          if (value) {
            lines.push(label + ': ' + value);
          }
        });

        bodyField.value = lines.join('\n');
      }

      divisionCheckboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
          syncDivisions();
          if (divisionError && getSelectedDivisions().length > 0) {
            divisionError.hidden = true;
          }
        });
      });

      if (isUpdateCheckbox) {
        isUpdateCheckbox.addEventListener('change', syncIsUpdate);
      }

      if (endDate && startDate) {
        startDate.addEventListener('change', function () {
          endDate.min = startDate.value || '';
        });
      }

      form.addEventListener('submit', function (event) {
        normalizeUrlField(websiteUrl);
        normalizeUrlField(logoUrl);
        syncDivisions();
        syncIsUpdate();
        buildSummary();

        if (getSelectedDivisions().length === 0) {
          event.preventDefault();
          if (divisionError) {
            divisionError.hidden = false;
          }
          var divisionGroup = form.querySelector('[data-division-group]');
          if (divisionGroup) {
            divisionGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return;
        }

        if (startDate && endDate && startDate.value && endDate.value && endDate.value < startDate.value) {
          event.preventDefault();
          endDate.setCustomValidity('End date must be on or after the start date.');
          endDate.reportValidity();
          return;
        }

        if (endDate) {
          endDate.setCustomValidity('');
        }

        // Shopify requires contact[body]; never allow an empty message through.
        if (bodyField && !bodyField.value.trim()) {
          bodyField.value = 'Tournament submission received.';
        }
      });
    });

    var successAlert = document.querySelector('.tournament-submission-section__alert--success');
    if (successAlert && window.location.search.indexOf('contact_posted=true') !== -1) {
      successAlert.focus();
      successAlert.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTournamentSubmissionForms);
  } else {
    initTournamentSubmissionForms();
  }

  document.addEventListener('shopify:section:load', initTournamentSubmissionForms);
})();
